export default __webpack_public_path__ + "static/media/client-logo-4.df8cfee8.png";